import { NgModule } from '@angular/core';
import { ErrorPagoComponent } from './error-pago/error-pago.component';
import { GeneracionProductoComponent } from './generacion-proceso-exito/generacion.component';
import { LayoutComponent } from './layout/layout.component';
import { PagesRoutingModule } from './pages-routing.component';
import { ValidacionPagoProactivoComponent } from './validacion-pago-proactivo/validacion-pago-proactivo';

import { SharedModule } from 'src/app/shared/shared.module';
import { SteppersModule } from '../components/steppers/steppers.module';

import { MatSnackBarModule } from '@angular/material';
import { DatosComercioProviderVM } from 'src/app/view-model/providers/services/datos-comercio/datos-comercio.provider';
import { MarketplaceRedirectProvider } from 'src/app/view-model/providers/services/marketplace-redirect/marketplace-redirect.provider';
import { DatosComercioServiceVM } from 'src/app/view-model/services/datos-comercio.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { AnalisisFinancieroComponent } from './analisis-financiero/analisis-financiero.component';
import { FechaEntregasComponent } from './generacion-proceso-exito/fecha-entrega/fecha-entrega.component';
import { PasosSeguirComponent } from './generacion-proceso-exito/pasos-a-seguir/pasos-seguir.component';
import { SeguimientoComponent } from './generacion-proceso-exito/seguimiento/seguimiento.component';
import { SpinnerReturExternalComponent } from './spinner-retur-external/spinner-retur-external.component';

@NgModule({
    declarations: [
        GeneracionProductoComponent,
        ErrorPagoComponent,
        LayoutComponent,
        FechaEntregasComponent,
        PasosSeguirComponent,
        SeguimientoComponent,
        AnalisisFinancieroComponent,
        SpinnerReturExternalComponent,
        ValidacionPagoProactivoComponent
    ],
    imports: [
        // CommonModule,
        PagesRoutingModule,
        SharedModule,
        SteppersModule,
        MatSnackBarModule
    ],
    providers: [
        {
            provide: MarketplaceRedirectService,
            useClass: MarketplaceRedirectProvider
        },
        {
            provide: DatosComercioServiceVM,
            useClass: DatosComercioProviderVM
        }
    ],
    exports: [
        GeneracionProductoComponent,
        ErrorPagoComponent,
        LayoutComponent,
        PagesRoutingModule,
        FechaEntregasComponent,
        PasosSeguirComponent,
        SeguimientoComponent,
        SpinnerReturExternalComponent,
        ValidacionPagoProactivoComponent
    ]
})
export class PagesModule { }
